import * as React from 'react';

import { BillRecord } from '@rematter/modules/finance/types';
import { Button, Menu } from '@rematter/ui-web';
import { BanknoteArrowDown, Eye, MoreHorizontal, Trash2 } from 'lucide-react';

import { useTranslations } from '@/finance/i18n/useTranslations';

type BillActionMenuProps = {
  bill: BillRecord;
  onPay: (bill: BillRecord) => void;
  onVoid: (bill: BillRecord) => void;
  onViewDetails: (bill: BillRecord) => void;
};

export const BillActionMenu = ({
  bill,
  onPay,
  onVoid,
  onViewDetails,
}: BillActionMenuProps) => {
  const t = useTranslations();

  const menuItems = React.useMemo(
    () => [
      {
        key: 'pay',
        label: t.bills.list.buttons.pay,
        icon: <BanknoteArrowDown className="size-4" />,
        onAction: () => onPay(bill),
        isDisabled: bill.status !== 'Pending',
      },
      {
        key: 'void',
        label: t.bills.list.buttons.void,
        icon: <Trash2 className="size-4" />,
        color: 'failure',
        onAction: () => onVoid(bill),
        isDisabled: bill.status === 'Voided' || bill.status === 'Paid',
      },
      {
        key: 'viewDetails',
        label: t.bills.list.buttons.viewDetails,
        icon: <Eye className="size-4" />,
        onAction: () => onViewDetails(bill),
      },
    ],
    [bill, onPay, onVoid, onViewDetails, t],
  );

  return (
    <div className="@BillActionMenu flex justify-center">
      <Menu
        trigger={
          <Button size="icon" icon={<MoreHorizontal />} variant="outline" />
        }
        items={menuItems}
      />
    </div>
  );
};
